<div class="battery-counter counter">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 240 120" width="240" [attr.height]="height">
        <defs>
            <linearGradient id="linear-gradient" x1="0" y1="120" x2="240" y2="120" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="green" />
                <stop offset=".33" stop-color="yellow" />
                <stop offset=".66" stop-color="orange" />
                <stop offset="1" stop-color="red" />
            </linearGradient>
        </defs>
        <circle transform="rotate(180 120 120)" fill="none" stroke-width="30" [attr.stroke-dasharray]="half" [attr.stroke-dashoffset]="dashOffset" stroke="url(#linear-gradient)" cx="120" cy="120" r="100" />
    </svg>
    <div class="digit">{{ percent }}<span>%</span></div>
</div>